export default "__VITE_ASSET__Bke4TtNA__"